export function getRankOption(data: any, name: string) {
  data = data.reverse()
  return {
    dataset: [
      {
        id: 'bar_raw',
        source: data
      }
    ],
    legend: {
      left: 10
    },
    grid: { left: '50%', right: '5%' },
    xAxis: {
      splitLine: { show: false },
      axisLabel: {
        hideOverlap: true
      }
    },
    yAxis: {
      type: 'category',
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        show: true,
        width: 250,
        overflow: 'truncate'
      }
    },
    series: [
      {
        type: 'bar',
        name: name,
        datasetId: 'bar_raw',
        encode: {
          x: 'num',
          y: 'title'
        },
        label: {
          show: true,
          position: 'insideRight'
        }
      }
    ]
  }
}

export function getLiveOption(data: any) {
  return {
    dataset: [
      {
        id: 'dataset_raw',
        source: data
      }
    ],
    legend: {
      top: 10
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        align: 'left'
      }
    },
    xAxis: {
      type: 'category',
      nameLocation: 'middle'
    },
    dataZoom: [
      {
        type: 'slider',
        show: true,
        xAxisIndex: [0],
        start: 100 - (30 / data.length) * 100,
        end: 100
      }
    ],
    yAxis: {},
    series: [
      {
        name: '直播观看总人数',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'stDate',
          y: 'totalCount',
          itemName: 'stDate',
          tooltip: ['totalCount']
        }
      },
      {
        name: '直播观看超过10分钟人数',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'stDate',
          y: 'tenCount',
          itemName: 'stDate',
          tooltip: ['tenCount']
        }
      },
      {
        name: '直播观看超过20分钟人数',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'stDate',
          y: 'twentyCount',
          itemName: 'stDate',
          tooltip: ['twentyCount']
        }
      },
      {
        name: '直播观看超过30分钟人数',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'stDate',
          y: 'thirtyCount',
          itemName: 'stDate',
          tooltip: ['thirtyCount']
        }
      }
    ]
  }
}

export function getOnlineNumberOption(data: any) {
  return {
    dataset: [
      {
        id: 'dataset_raw',
        source: data
      }
    ],
    legend: {
      top: 10
    },
    tooltip: {
      trigger: 'axis',
      textStyle: {
        align: 'left'
      }
    },
    xAxis: {
      type: 'category',
      nameLocation: 'end'
    },
    dataZoom: [
      {
        type: 'slider',
        show: true,
        xAxisIndex: [0],
        start: 100 - (13 / data.length) * 100,
        end: 100
      }
    ],
    yAxis: {},
    series: [
      {
        name: '直播时间段观看人数',
        type: 'line',
        datasetId: 'dataset_raw',
        showSymbol: false,
        encode: {
          x: 'stDate',
          y: 'totalCount',
          itemName: 'stDate',
          tooltip: ['totalCount']
        }
      }
    ]
  }
}
